<template>
  <admin-entity-canvas>
    <template #floating-panel>
      <hit-floating-panel
        :navigation-items="navigationItems"
        :selected-instance="t('hit-admin.common.tracker', 2)"
        :data-object-class="TrackerClass"
      />
    </template>
    <template #body>
      <hit-panel :resizable="false" panel-id="tracker.list">
        <template #body>
          <hit-container
            ref="trackerTable"
            :attributes="trackerAttributes"
            route="tracker"
            multiple
            paginate
          >
            <template #default="container">
              <hit-container-table
                :container="container"
                :items-selectable="true"
                auto-complete-id="tracker"
                router-link="trackerDetail"
                :addable="false"
                deletable
              />
            </template>
          </hit-container>
        </template>
      </hit-panel>
    </template>
  </admin-entity-canvas>
</template>

<script>
import {defineComponent} from 'vue';
import AdminEntityCanvas from '../../components/hit/AdminEntityCanvas.vue';
import HitFloatingPanel from '@/components/hit/navigation/HitFloatingPanel.vue';
import {HitPanel} from '@hit/components';
import {HitContainer, HitContainerTable} from '@hit/base/src/components';
import {Tracker} from '@hit/base';
import {useI18n} from 'vue-i18n';
import {HitRouteUtils} from '../../utils/routes';

export default defineComponent({
  name: 'TrackerList',
  setup() {
    const {t} = useI18n();
    return {t};
  },
  components: {
    AdminEntityCanvas,
    HitFloatingPanel,
    HitPanel,
    HitContainer,
    HitContainerTable,
    Tracker,
  },
  data() {
    return {
      trackerAttributes: Tracker.listDisplayAttrs,
    };
  },
  computed: {
    navigationItems() {
      return [HitRouteUtils.getEntityListRoute('tracker')];
    },
    TrackerClass() {
      return Tracker;
    },
  },
});
</script>

<style lang="scss" scoped></style>
